'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _objectAssign = require('object-assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _Base = require('./Base');

var _Base2 = _interopRequireDefault(_Base);

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Sets margin, padding, and width and works independently or as a child of <Flex />.
 */

var Box = function Box(_ref, _ref2) {
  var flex = _ref.flex;
  var auto = _ref.auto;
  var align = _ref.align;
  var order = _ref.order;
  var col = _ref.col;

  var props = _objectWithoutProperties(_ref, ['flex', 'auto', 'align', 'order', 'col']);

  var reflexbox = _ref2.reflexbox;

  var _config$reflexbox = _extends({}, _config2.default, reflexbox);

  var breakpoints = _config$reflexbox.breakpoints;


  function w(n) {
    return n ? n / 12 * 100 + '%' : null;
  }

  var width = w(col);

  if (typeof window !== 'undefined') {
    Object.keys(breakpoints).forEach(function (key) {
      if (props[key] && window.matchMedia(breakpoints[key]).matches) {
        width = w(props[key]) || width;
      }
    });
  }

  Object.keys(breakpoints).forEach(function (key) {
    delete props[key];
  });

  var sx = (0, _objectAssign2.default)({}, auto ? { flex: '1 1 auto' } : null, flex ? { display: 'flex' } : null, align ? { alignSelf: align } : null, order ? { order: order } : null, width ? { width: width } : null, width ? { flexBasis: width } : null);

  return _react2.default.createElement(_Base2.default, _extends({}, props, {
    _style: sx,
    _className: 'Box' }));
};

Box.propTypes = {
  /** Sets flex: 1 1 auto */
  auto: _react2.default.PropTypes.bool,
  /** Sets display: flex */
  flex: _react2.default.PropTypes.bool,
  /** Sets align-self */
  align: _react2.default.PropTypes.oneOf(['stretch', 'center', 'baseline', 'flex-start', 'flex-end']),
  /** Sets order */
  order: _react2.default.PropTypes.number,
  /** Sets width and flex-basis based on a 12 column grid */
  col: _react2.default.PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /** Passes in a custom element or component */
  is: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.object, _react2.default.PropTypes.func]),

  /** Sets padding based on a scale of 0–4 */
  m: _react2.default.PropTypes.number,
  /** Sets padding-left and padding-right based on a scale of 0–4 */
  mx: _react2.default.PropTypes.number,
  /** Sets margin-top and margin-bottom based on a scale of 0–4 */
  my: _react2.default.PropTypes.number,
  /** Sets margin-top based on a scale of 0–4 */
  mt: _react2.default.PropTypes.number,
  /** Sets margin-bottom based on a scale of 0–4 */
  mb: _react2.default.PropTypes.number,
  /** Sets margin-left based on a scale of 0–4 */
  ml: _react2.default.PropTypes.number,
  /** Sets margin-right based on a scale of 0–4 */
  mr: _react2.default.PropTypes.number,

  /** Sets padding based on a scale of 0–4 */
  p: _react2.default.PropTypes.number,
  /** Sets padding-left and padding-right based on a scale of 0–4 */
  px: _react2.default.PropTypes.number,
  /** Sets padding-top and padding-bottom based on a scale of 0–4 */
  py: _react2.default.PropTypes.number,
  /** Sets padding-top based on a scale of 0–4 */
  pt: _react2.default.PropTypes.number,
  /** Sets padding-bottom based on a scale of 0–4 */
  pb: _react2.default.PropTypes.number,
  /** Sets padding-left based on a scale of 0–4 */
  pl: _react2.default.PropTypes.number,
  /** Sets padding-right based on a scale of 0–4 */
  pr: _react2.default.PropTypes.number
};

Box.contextTypes = {
  reflexbox: _react2.default.PropTypes.shape({
    breakpoints: _react2.default.PropTypes.object,
    scale: _react2.default.PropTypes.array
  })
};

exports.default = Box;


//////////////////
// WEBPACK FOOTER
// ./node_modules/reflexbox/dist/Box.js
// module id = ./node_modules/reflexbox/dist/Box.js
// module chunks = 0